import { decimalToPercentage, numberToText } from "./transformators";

export const setInsuranceVars = (inco, globalparams, setUSposition, setUSpositionData, positionEdits, editID) => {
  const insuranceRates = {
    DAP: { rate: globalparams?.DAPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIP: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIF: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CPT: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CFR: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
  };
  const { rate, factor } = insuranceRates[inco] || { rate: 0, factor: 0 };
  setUSposition((prev) => ({
    ...prev,
    insurancerate: decimalToPercentage(rate),
    insurancefactor: numberToText(factor),
  }));
  setUSpositionData((prev) => ({
    ...prev,
    insurancerate: rate,
    insurancefactor: factor,
  }));

  // positionEdits.current.push({
  //   name: "insurancerate",
  //   value: decimalToPercentage(rate),
  //   num: rate,
  //   editID: editID - 1,
  // });

  // positionEdits.current.push({
  //   name: "insurancefactor",
  //   value: numberToText(factor),
  //   num: factor,
  //   editID: editID - 1,
  // });
};

// export const sumvalues = (...args) => {
//   var s = 0;
//   for (const i in args) {
//     s += Number(args[i]);
//   }
//   return new Promise((resolve, reject) => {
//     resolve(s);
//   });
// };
export const sumvalues = async (...args) => {
  return args.reduce((acc, val) => acc + (Number(val) || 0), 0);
};

// export const multiplyvalues = (...args) => {
//   var p = 1;
//   for (const i in args) {
//     p *= Number(args[i]);
//   }
//   return new Promise((resolve, reject) => {
//     resolve(p);
//   });
// };
export const multiplyvalues = async (...args) => {
  return args.reduce((product, val) => product * (Number(val) || 0), 1);
};

export const dividevalues = (a, b) => {
  return new Promise((resolve, reject) => {
    if (b > 0) {
      resolve(a / b);
    } else {
      resolve(0);
    }
  });
};

// export const interestcostcalc = (tcost, payterms, rate) => {
//   return new Promise((resolve, reject) => {
//     var intcost = 0;
//     payterms.forEach((item) => {
//       intcost += (item.portion * rate * item.termdays * tcost) / 360;
//     });
//     resolve(intcost);
//   });
// };
// export const interestcostcalc = (tcost, payterms, rate) => {
//   return new Promise((resolve, reject) => {
//     var intcost = 0;
//     payterms.forEach((item) => {
//       if (item.payTypeID === 3) {
//         intcost += (item.portion * rate * item.termdays * tcost) / 360;
//       }
//     });
//     resolve(intcost);
//   });
// };

export const interestcostcalc = (tcost, payterms = [], rate = 0) => {
  return payterms.reduce((intcost, item) => {
    if (item?.payTypeID === 3) {
      intcost += (item.portion * rate * item.termdays * tcost) / 360;
    }
    return intcost;
  }, 0);
};

export const storagepmtcalc = (stgdays, stgfix, stgvar, qty, qtypallets, accrualpd) => {
  return new Promise((resolve, reject) => {
    qty > 0 && accrualpd > 0
      ? resolve(stgfix / qty + (Math.floor(stgdays / accrualpd) * stgvar * qtypallets) / qty)
      : resolve(0);
  });
};

export const stgpmtcalc = (stgdays, stgfix, stgvar, qty, qtypallets, accrualpd) => {
  if (qty > 0 && accrualpd > 0) return stgfix / qty + (Math.floor(stgdays / accrualpd) * stgvar * qtypallets) / qty;
  else return 0;
};
